import { accSub, accAdd } from '@/utils/util.js'
const shop = {
  namespaced: true,
  state: {
    // 购物类型
    shopType: 0,
    // 购物满减描述仅针对配送到家
    shopText: '',
    // 影院取货购物车
    cinemaShopCart: {},
    // 配送到家购物车
    deliveryShopCart: {}
  },
  mutations: {
    setCinemaShopCart (state, payload) {
      state.cinemaShopCart = payload
    },
    setDeliveryShopCart (state, payload) {
      state.deliveryShopCart = payload
    },
    setShopType (state, payload) {
      state.shopType = payload
    },
    setShopText(state, payload) {
      state.shopText = payload
    },
    decrementPrice (state, payload) {
      // state.totalPrice -= payload
      state.totalPrice = accSub(state.totalPrice, payload)
    },
    incrementCount (state) {
      state.totalCount++
    },
    decrementCount (state) {
      if (state.totalCount <= 0) {
        return
      }
      state.totalCount--
    },
  },
  actions: {
    incrementPrice (context, payload) {
      context.commit('incrementPrice', payload)
    },
    decrementPrice (context, payload) {
      context.commit('decrementPrice', payload)
    },
    incrementCount (context) {
      context.commit('incrementCount')
    },
    decrementCount (context) {
      context.commit('decrementCount')
    },
    setCinemaShopCart (context, payload) {
      context.commit('setCinemaShopCart', payload)
    },
    setDeliveryShopCart (context, payload) {
      context.commit('setDeliveryShopCart', payload)
    },
    setShopType (context, payload) {
      context.commit('setShopType', payload)
    },
    setShopText (context, payload) {
      context.commit('setShopText', payload)
    }
  }
}

export default shop



// WEBPACK FOOTER //
// ./src/store/shop.js